import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";

import "./index.css"; // 🔥 THIS IS CRITICAL (Tailwind)

// IMMEDIATE and COMPREHENSIVE ResizeObserver error suppression
(function() {
  // 1. Override console methods first
  const origError = console.error;
  console.error = (...args) => {
    const msg = typeof args[0] === 'string' ? args[0] : String(args[0] || '');
    if (msg.includes('ResizeObserver')) {
      return;
    }
    origError.apply(console, args);
  };

  const origWarn = console.warn;
  console.warn = (...args) => {
    const msg = typeof args[0] === 'string' ? args[0] : String(args[0] || '');
    if (msg.includes('ResizeObserver')) {
      return;
    }
    origWarn.apply(console, args);
  };

  // 2. Override window.onerror to catch unhandled errors
  const originalWindowError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    const msg = String(message || '');
    if (msg.includes('ResizeObserver')) {
      return true; // Prevent default error handling
    }
    if (originalWindowError) {
      return originalWindowError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  // 3. Add error event listener in capture phase (catches before React)
  window.addEventListener('error', function(e) {
    const msg = e.message || String(e.error || '');
    if (msg.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
      return true;
    }
  }, true); // Use capture phase

  // 4. Catch unhandled promise rejections
  window.addEventListener('unhandledrejection', function(e) {
    const msg = String(e.reason || '');
    if (msg.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
})();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </ErrorBoundary>
);
